<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-toolbar dark color="primary">
        <v-toolbar-title>
          <div style="display: flex; align-items: center">
            <template v-if="icon">
              <div style="display: inline-block; vertical-align: middle">
                <v-icon x-large>{{ icon }}</v-icon>
              </div>
            </template>
            <div
              class="headline"
              style="
                display: inline-block;
                vertical-align: middle;
                padding-left: 20px;
              "
            >
              {{ title }}
            </div>
          </div>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="$emit('onCancelClicked')" dark>
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
    </v-flex>
    <v-flex xs12 px-5 py-2>
      <slot />
    </v-flex>
  </v-layout>
</template>

<script>
import Toolbar from './Toolbar'

export default {
  components: {
    Toolbar,
  },
  props: {
    title: String,
    icon: String,
    isLoading: Boolean,
    toolbarActions: {
      type: Array,
      validator: (val) => {
        return val.every((action) => action.hasOwnProperty('emitEvent'))
      },
    },
  },
  data: () => ({}),
}
</script>